import { useTranslation } from 'react-i18next'

import NoChangeableOrdersMessage from '@/returns/pages/TransactionsPage/NoChangeableOrdersMessage/NoChangeableOrdersMessage'

const InfoMessage = ({ notUsableOrders, selectedOrders }) => {
  const { t } = useTranslation()

  return (
    <>
      {notUsableOrders?.length > 0 && selectedOrders?.length > 0 && (
        <>
          <p>
            {t(
              'Se rechazarán todos los productos pendientes de {{usableOrders}} de las {{totalOrders}} transacciones seleccionadas.',
              {
                totalOrders: selectedOrders.length,
                usableOrders: Number(selectedOrders.length) - Number(notUsableOrders.length),
              }
            )}
          </p>
          <NoChangeableOrdersMessage notUsableOrders={notUsableOrders} />
        </>
      )}
      {notUsableOrders?.length <= 0 && selectedOrders?.length > 0 && (
        <p>
          {selectedOrders.length > 1 &&
            t('Se rechazarán todos los productos pendientes de las {{totalOrders}} transacciones seleccionadas.', {
              totalOrders: selectedOrders.length,
            })}
          {selectedOrders.length === 1 &&
            t('Se rechazarán todos los productos pendientes de la transacción seleccionada.')}
        </p>
      )}
    </>
  )
}

export default InfoMessage
